__turbopack_context__.v({
  "className": "barlowcondensedfont_a84adc8a-module__ONSJ-q__className",
  "variable": "barlowcondensedfont_a84adc8a-module__ONSJ-q__variable",
});
